import clsx from 'clsx';
import React, { useState } from 'react';
import ReactPlayer from 'react-player';
import { config } from '../../services/Constants/AppConstants';
import './DiastasisRectiVideo.scss';

interface DiastasisRectiVideoProps {
  isDisabled?: boolean;
}

export const DiastasisRectiVideo: React.FC<DiastasisRectiVideoProps> = ({ isDisabled }) => {
  const [isPlayVideo, setPlayVideo] = useState(true);

  const handlePlayVideo = () => {
    setPlayVideo(!isPlayVideo);
  };

  return (
    <div className="videoContainer">
      <div className={clsx('video-player-container', { disabled: isDisabled })}>
        <ReactPlayer
          playing
          onPlay={handlePlayVideo}
          className="video-player"
          light={config.DIASTASIS_RECTI_VIDEO_THUMBNAIL}
          url={config.DIASTASIS_RECTI_VIDEO_URL}
          height="100%"
          width="100%"
          controls
        />
        <p className="video-description">
          Watch this short video to learn more about abdominal separation.
        </p>
      </div>
    </div>
  );
};
